import { useIntl } from "react-intl";

const GoalsProjectsCommunication = () => {
    const intl = useIntl();

    const messages = {
        title: intl.formatMessage({
            id: "ConfluencePricingPageTeam24.features.goalsProjectsCommunication.title",
            defaultMessage: "Goals, projects, and communication"
        }),
        body: intl.formatMessage({
            id: "ConfluencePricingPageTeam24.features.goalsProjectsCommunication.body",
            defaultMessage:
                "Share status updates on how projects and goals are progressing."
        })
    };

    return (
        <div>
            <h2>{messages.title}</h2>
            <p>{messages.body}</p>
        </div>
    );
};

export default GoalsProjectsCommunication;
